import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';
import { CommandWithPayload, Command } from './commands/command';
import { CommandACK } from './commands/command-ACK';
import { CloseChatCommand } from './commands/close-chat-command';
import { InitChatCommand } from './commands/init-chat-command';
import { UpdateLastMessageCommand } from './commands/update-last-message-command';
import { ProcessNewMessageCommand } from './commands/update-new-message-command';

@Injectable({
   providedIn: 'root',
})
export class ChatJsApiService {
   public ACKs: Subject<CommandACK> = new Subject();
   public Commands: Subject<Command | CommandWithPayload<any>> = new Subject();

   public initialize(): void {
      this.registerEventListener();
   }

   public initChat(chatId: ChatId, chatWindow: Window): void {
      chatWindow.postMessage(new InitChatCommand(chatId), '*');
   }

   public closeChat(chatId: ChatId, chatWindow: Window): void {
      chatWindow.postMessage(new CloseChatCommand(chatId), '*');
   }

   private registerEventListener(): void {
      window.addEventListener(
         'message',
         (event: MessageEvent<any>) => {
            // usually you'd validate event.origin so only trusted sites can send us messages.
            // since we don't know the origin of the external chat app, we can't validate it.

            const command = event.data;

            // ignore unknown message formats, as well as ngxs actions
            if (_.isNil(command) || _.isNil(command.type) || _.isNil(command.chatId) || command.type === 'ACTION') return;

            if (command.type.endsWith('-ack')) this.ACKs.next(new CommandACK(command.type, this.mapChatId(command)));
            if (command.type === CloseChatCommand.commandType) this.handleCommand(command);
            if (command.type === UpdateLastMessageCommand.commandType) this.handleCommand(command);
            if (command.type === ProcessNewMessageCommand.commandType) this.handleCommand(command);
         },
         false
      );
   }

   private handleCommand<T extends Command>(receivedCommand: any): void {
      const command = receivedCommand as T;
      command.chatId = this.mapChatId(receivedCommand);

      this.Commands.next(command);
   }

   private mapChatId(data: any): ChatId {
      return new ChatId(data.chatId.callId, data.chatId.messageId);
   }
}
